import { createContext } from 'react';

import type { NSendoutsProvider } from '@app/providers/SendoutsProvider/SendoutsProvider.types';

export const SendoutsContext = createContext<NSendoutsProvider.State>({
  searchTerm: '',
  statusOptions: [],
  channelOptions: [],
  integrationOptions: [],
  selectedStatusOptions: [],
  selectedChannelOptions: [],
  selectedIntegrationOptions: [],
  setSearchTerm: () => {},
  setStatusOptions: () => {},
  setChannelOptions: () => {},
  setIntegrationOptions: () => {},
  setSelectedStatusOptions: () => {},
  setSelectedChannelOptions: () => {},
  setSelectedIntegrationOptions: () => {},
});
